function initMobileProductSlider() {
  // Vérifier si on est sur mobile
  if (window.innerWidth >= 750) {
    return;
  }
  
  // Vérifier que Swiper est chargé
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper.js not loaded, retrying...');
    // Réessayer après un court délai
    setTimeout(initMobileProductSlider, 100);
    return;
  }
  
  // Trouver le conteneur swiper (slider-component avec classe swiper)
  const swiperContainer = document.querySelector('slider-component.swiper[id^="GalleryViewer"]');
  if (!swiperContainer) {
    console.warn('Swiper container not found');
    return;
  }
  
  // Trouver le wrapper (ul avec classe swiper-wrapper) - c'est l'élément qui contient les slides
  const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
  if (!swiperWrapper) {
    console.warn('Swiper wrapper not found');
    return;
  }
  
  // Vérifier qu'il y a des slides
  const slides = swiperWrapper.querySelectorAll('.swiper-slide');
  if (slides.length === 0) {
    console.warn('No swiper slides found');
    return;
  }
    
  // Récupérer media-gallery pour la synchronisation
  const mediaGallery = document.querySelector('media-gallery');
  
  // Désactiver complètement le comportement natif du slider-component sur mobile
  const sliderElement = swiperContainer.querySelector('[id^="Slider-"]');
  if (sliderElement) {
    // Retirer l'écouteur de scroll du slider-component
    if (swiperContainer.update) {
      const updateHandler = swiperContainer.update.bind(swiperContainer);
      // Créer une nouvelle fonction qui ne fait rien pour remplacer update
      swiperContainer.update = function() {
        // Ne rien faire - Swiper gère maintenant
        return;
      };
      sliderElement.removeEventListener('scroll', updateHandler);
      // Stocker la référence pour pouvoir la réactiver si nécessaire
      swiperContainer._originalUpdateHandler = updateHandler;
    }
    
    // Désactiver complètement les boutons du slider natif
    const prevButton = swiperContainer.querySelector('button[name="previous"]');
    const nextButton = swiperContainer.querySelector('button[name="next"]');
    if (prevButton) {
      prevButton.style.pointerEvents = 'none';
      prevButton.style.opacity = '0';
    }
    if (nextButton) {
      nextButton.style.pointerEvents = 'none';
      nextButton.style.opacity = '0';
    }
    
    // Désactiver le scroll natif sur l'élément
    sliderElement.style.overflow = 'hidden';
    sliderElement.style.touchAction = 'pan-x'; // Permettre le swipe horizontal uniquement
  }
  
  // S'assurer que le wrapper parent (slider-component) a les bonnes dimensions
  swiperContainer.style.width = '100%';
  swiperContainer.style.overflow = 'hidden';
  swiperContainer.style.position = 'relative';
  
  // S'assurer que l'élément ul (wrapper) a les bonnes dimensions
  swiperWrapper.style.display = 'flex';
  swiperWrapper.style.flexDirection = 'row';
  
  
  let swiperInstance = null;
  
  // Fonction pour initialiser les dimensions et Swiper
  const initDimensionsAndSwiper = () => {
    // Attendre que le conteneur ait ses dimensions finales
    // Utiliser getBoundingClientRect pour obtenir la largeur réelle
    const rect = swiperContainer.getBoundingClientRect();
    const containerWidth = rect.width || swiperContainer.offsetWidth || swiperContainer.clientWidth;
    
    if (!containerWidth || containerWidth === 0) {
      // Réessayer si les dimensions ne sont pas encore disponibles
      requestAnimationFrame(initDimensionsAndSwiper);
      return;
    }
        
    // S'assurer que chaque slide a exactement la largeur du conteneur
    slides.forEach((slide, index) => {
      // Retirer toute largeur en pourcentage et forcer la largeur en pixels
      slide.style.width = containerWidth + 'px';
      slide.style.minWidth = containerWidth + 'px';
      slide.style.maxWidth = containerWidth + 'px';
      slide.style.flexShrink = '0';
      slide.style.flexGrow = '0';
      slide.style.opacity = '1';
      slide.style.visibility = 'visible';
      // S'assurer qu'il n'y a pas de margin ou padding qui affecte la largeur
      slide.style.marginLeft = '0';
      slide.style.marginRight = '0';
      slide.style.paddingLeft = '2px';
      slide.style.paddingRight = '2px';
      slide.style.boxSizing = 'border-box';
      // Forcer l'offset manuellement
      slide.swiperSlideOffset = containerWidth * index;
    });
    
    // Calculer la largeur totale du wrapper (largeur conteneur × nombre de slides)
    const totalWidth = containerWidth * slides.length;
    swiperWrapper.style.width = totalWidth + 'px';
    swiperWrapper.style.minWidth = totalWidth + 'px';
    swiperWrapper.style.transform = 'translate3d(0px, 0, 0)'; // Réinitialiser la position
    swiperWrapper.style.boxSizing = 'border-box';
    
    // Initialiser Swiper seulement si ce n'est pas déjà fait
    if (!swiperInstance) {
      initSwiper();
    }
  };
  
    // Fonction pour initialiser Swiper
  const initSwiper = () => {
    
    // Initialiser Swiper sur le slider-component (conteneur parent)
    const swiper = new Swiper(swiperContainer, {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 500,
    
    // Spécifier explicitement les classes
    wrapperClass: 'swiper-wrapper',
    slideClass: 'swiper-slide',
    slideActiveClass: 'is-active',
    
    // Pagination - bullets classiques
    pagination: {
      el: swiperContainer.querySelector('.swiper-pagination'),
      clickable: true,
      dynamicBullets: false, // Désactiver les bullets dynamiques
      type: 'bullets',
    },
    
    // Navigation au clavier
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    
    // Touch settings - IMPORTANT pour le swipe
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    allowTouchMove: true,
    touchStartPreventDefault: true, // Empêcher le scroll natif
    touchMoveStopPropagation: true, // Empêcher la propagation
    simulateTouch: false, // Désactiver la simulation sur desktop
    threshold: 5, // Seuil minimum de mouvement pour déclencher le swipe
    longSwipesRatio: 0.5, // Ratio pour les swipes longs
    longSwipesMs: 300, // Durée pour un swipe long
    
    // Performance
    watchSlidesProgress: true,
    watchOverflow: true,
    
    // Forcer la largeur des slides - utiliser la largeur du conteneur
    width: null,
    autoHeight: false,
    // S'assurer que slidesPerView est bien à 1
    slidesPerGroup: 1, // Important : ne pas grouper les slides
    // Désactiver le calcul automatique des offsets
    calculateHeight: false,
    // S'assurer qu'on n'utilise pas de loop
    loop: false,
    // Désactiver le centrage des slides
    centeredSlides: false,
    // Désactiver le centrage des slides bounds
    centeredSlidesBounds: false,
    
  });
  
    swiperInstance = swiper;
  };
  
  // Initialiser les dimensions et Swiper après que le DOM soit rendu
  requestAnimationFrame(initDimensionsAndSwiper);
  
  // Ajouter la navigation au clavier avec les flèches (sera ajouté après l'init de Swiper)
  const setupKeyboardNavigation = () => {
    if (!swiperContainer._swiperInstance) {
      setTimeout(setupKeyboardNavigation, 100);
      return;
    }
    
    const handleKeyDown = (event) => {
      if (!swiperContainer._swiperInstance) return;
    
    // Vérifier si on est dans le contexte de la galerie
    const isInGallery = swiperContainer.contains(document.activeElement) || 
                        document.activeElement === document.body ||
                        swiperContainer.matches(':hover');
    
    if (!isInGallery) return;
    
    switch(event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        swiperContainer._swiperInstance.slidePrev();
        break;
      case 'ArrowRight':
        event.preventDefault();
        swiperContainer._swiperInstance.slideNext();
        break;
    }
  };
  
    document.addEventListener('keydown', handleKeyDown);
    
    // Stocker le handler pour pouvoir le retirer plus tard
    swiperContainer._keyboardHandler = handleKeyDown;
  };
  
  setupKeyboardNavigation();
  
  // Gérer le changement d'orientation
  window.addEventListener('resize', debounce(() => {
    if (window.innerWidth >= 750 && swiperContainer._swiperInstance) {
      swiperContainer._swiperInstance.destroy(true, true);
      // Retirer la référence swiper du viewer
      if (mediaGallery && mediaGallery.elements && mediaGallery.elements.viewer) {
        delete mediaGallery.elements.viewer._swiperInstance;
      }
      delete swiperContainer._swiperInstance;
      
      // Retirer le handler clavier
      if (swiperContainer._keyboardHandler) {
        document.removeEventListener('keydown', swiperContainer._keyboardHandler);
        delete swiperContainer._keyboardHandler;
      }
      
      // Réactiver le comportement natif du slider-component
      const sliderElement = swiperContainer.querySelector('[id^="Slider-"]');
      if (sliderElement && swiperContainer._originalUpdateHandler) {
        sliderElement.addEventListener('scroll', swiperContainer._originalUpdateHandler);
        delete swiperContainer._originalUpdateHandler;
      }
    }
  }, 250));
}

// Fonction debounce
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Initialiser quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileProductSlider);
} else {
  initMobileProductSlider();
}